const ArrayUtils = {
    /**
     * Generates a new list removing the item at given index
     * @param {Array} array
     * @param {Number} index
     */
    removeItem: (array, index) => {
        if (!(array instanceof Array)) {
            throw new Error(`First parameter given must be an array: ${typeof array}`)
        }

        return [...array.slice(0, index), ...array.slice(index + 1, array.length)]
    },
    /**
     * Generates a new list replacing the given index with the given item
     * @param {Array} array
     * @param {Number} index
     * @param {*} item
     */
    insertItem: (array, index, item) => {
        if (!(array instanceof Array)) {
            throw new Error(`First parameter given must be an array: ${typeof array}`)
        }

        return [...array.slice(0, index), item, ...array.slice(index + 1, array.length)]
    },

    /**
     * Sanitizes a string array
     * @param {Array} array 
     * @param {string} array.item
     * @returns 
     */
    cleanStringArray: (array) => {
        if (!(array instanceof Array)) {
            throw new Error(`First parameter given must be an array: ${typeof array}`)
        }

        return array.map(sku => sku.trim())
            // Remove duplicates
            .reduce((carry, sku) => {
                if (carry.includes(sku)) {
                    return carry
                }

                return [...carry, sku]
            }, [])
            // Remove empty string
            .filter(sku => !!sku)
            .join(',')
    },
}

export default ArrayUtils
